import { render, staticRenderFns } from "./TagManager.vue?vue&type=template&id=c89cecd2&scoped=true"
import script from "./TagManager.ts?vue&type=script&lang=js&external"
export * from "./TagManager.ts?vue&type=script&lang=js&external"
import style0 from "./TagManager.scss?vue&type=style&index=0&id=c89cecd2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89cecd2",
  null
  
)

export default component.exports